import { LoginError } from "@faire/retailer-visitor-shared/components/AppSignIn/components/LoginError";
import { isError } from "@faire/web--source/common/typescriptUtils";
import { WebApiError } from "@faire/web-api--source/WebApiError";
export var convertErrorToLoginError = function(e, strictLocalize, isLoginAttempt) {
    if (e instanceof WebApiError) {
        if (e.httpStatusCode === 404) {
            return new LoginError(strictLocalize({
                id: "S6Fbcx",
                defaultMessage: [
                    {
                        type: 0,
                        value: "There\u2019s no account associated with that email. Try Again"
                    }
                ]
            }), e.httpStatusCode);
        } else if (e.httpStatusCode === 429) {
            return new LoginError(strictLocalize({
                id: "zyGQIV",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Your account has been locked due to too many failed login attempts, try again in an hour."
                    }
                ]
            }), e.httpStatusCode);
        } else if (e.httpStatusCode === 400 && (isLoginAttempt === null || isLoginAttempt === void 0 ? void 0 : isLoginAttempt.isMFALoginAttempt)) {
            return new LoginError(strictLocalize({
                id: "F7Xqi+",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Invalid combination of email address, code and password."
                    }
                ]
            }));
        }
        return new LoginError(e.message, e.httpStatusCode, e.responseData);
    }
    if (isError(e)) {
        return new LoginError(e.message);
    }
    return new LoginError(strictLocalize({
        id: "uuDgUP",
        defaultMessage: [
            {
                type: 0,
                value: "An error occured"
            }
        ]
    }));
};
